export default __webpack_public_path__ + "static/media/17884401_130907670782354_5641047300408986097_n_footer.fefb2e62.png";